app.controller('modalEWaybillReprintReasonCtrl', function ($scope, $uibModalInstance, params) {
    $scope.title = params && params.title ? params.title : 'Pilih alasan reprint';
    $scope.reasons = (params && params.reasons ? params.reasons : []).filter(function (item) {
        return item && item.reasonName;
    });
    $scope.selectedReasonId = $scope.reasons.length === 1 ? $scope.reasons[0].id : '';
    $scope.errorText = '';

    $scope.submit = function () {
        var selectedItem = ($scope.reasons || []).find(function (item) {
            return String(item.id) === String($scope.selectedReasonId || '');
        });

        if (!selectedItem) {
            $scope.errorText = 'Reason print wajib dipilih';
            return;
        }

        $uibModalInstance.close(selectedItem);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});